// This icon file is generated automatically.
var PCompassOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8zm3.1-9.19a.5.5 0 00-.38.01L5.48 5.48 3.63 9.72a.5.5 0 00.46.7.5.5 0 00.2-.04l4.24-1.86 1.85-4.23a.5.5 0 00-.28-.67zM8.01 7.35l.41.4-.66.67-.41-.4-2.41 1.05 1.05-2.41-.4-.4.67-.67.4.4 2.4-1.05-1.05 2.41zM6.26 5.59l-.67.67.4.4L7.35 8l.4.41.67-.66-.4-.41-1.36-1.36-.4-.4z", "fill-rule": "nonzero" } }] }, "name": "p-compass", "theme": "outlined" };
export default PCompassOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCompassOutlined.js
// module id = 3309
// module chunks = 0